import { Dialog as MuiDialog, DialogProps, Fade } from '@mui/material';
import { FC, ReactElement, Ref, forwardRef, ReactNode, useCallback } from 'react';

// import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>
) {
  return <Fade in ref={ref} {...props} />;
});

interface QSUrlDialogProps {
  onClose: () => void;
  children: ReactNode | ReactNode[];
  dialogProps?: Omit<DialogProps, 'open' | 'onClose'>;
}

const QSUrlDialog: FC<QSUrlDialogProps> = ({
  onClose,
  children,
  dialogProps,
}) => {
  return (
    <MuiDialog
      PaperProps={{
        sx: {
          margin: '14px',
          width: '90%',
        },
      }}
      open
      onClose={onClose}
      TransitionComponent={Transition}
      {...dialogProps}
    >
      {children}
    </MuiDialog>
  );
};

interface DialogWrapperProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode | ReactNode[];
  dialogProps?: Omit<DialogProps, 'open' | 'onClose'>;
}

const DialogWrapper: FC<DialogWrapperProps> = ({
  open,
  onClose: onCloseProp,
  children,
  dialogProps,
}) => {
  // remove setOpen we dont need it
  const onClose = useCallback(() => {
    onCloseProp();
  }, [onCloseProp]);

  if (open) {
    return (
      <QSUrlDialog onClose={onClose} dialogProps={dialogProps}>
        {children}
      </QSUrlDialog>
    );
  }

  return null;
};

export default DialogWrapper;
